import { useEffect, useState } from "react";
import validateForm from "features/maintenance/utils/validateForm";
import FieldRenderer from "./FieldRenderer";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import DText from "components/common/DText";

export default function MaintenanceForm({
    resource,
    form,
    setForm,
    showValidation,
    items
}) {
    const [errors, setErrors] = useState({});

    useEffect(() => {
        setErrors(validateForm(resource.fields, form, items));
    }, [resource, form]);

    return (
        <GridContainer direction="column" spacing={1}>
            {resource.fields.map((field) => {
                return (
                    <GridItem>
                        <GridContainer noWrap alignItems="center">
                            <GridItem xs={4}>
                                <DText light sm>
                                    {field.label}
                                </DText>
                            </GridItem>

                            <GridItem xs={8} key={field.name}>
                                <FieldRenderer
                                    key={field.name}
                                    field={field}
                                    form={form}
                                    setForm={setForm}
                                    errors={errors}
                                    showValidation={showValidation}
                                    resource={resource}
                                    noLabel
                                />
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                );
            })}
        </GridContainer>
    );
}
